import React from "react";
import { SEO, MainLayout, SignUp } from "../../../components";

const SignUpPage = () => {
  return (
    <>
      <SEO title="sign up" />
      <MainLayout>
        <SignUp />
      </MainLayout>
    </>
  );
};

export default SignUpPage;
